(ns portal.advertiser-modal.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.advertiser :refer [create-advertiser-mutation]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [portal.advertiser-modal.db :as form]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui modal-content []
  ($ Stack
     {:gap 3
      :sx #js {:py 2
               :minWidth 580}}
     ($ form-field
        {:label "Name"
         :err-msg (form/use-error-message [:name])}
        ($ input
           (merge (form/use-bind-control [:name])
                  {:type "text"
                   :data-testid "name-input"})))
     ($ form-field
        {:label "Shortcode"
         :err-msg (form/use-error-message [:code])}
        ($ input
           (merge (form/use-bind-control [:code])
                  {:type "text"
                   :data-testid "shortcode-input"})))
     ($ form-field
        {:label "Backup URL"
         :err-msg (form/use-error-message [:backupLandingPageUrl])}
        ($ input
           (merge (form/use-bind-control [:backupLandingPageUrl])
                  {:type "text"
                   :data-testid "backup-url-input"})))))

(defmodal create-advertiser :advertiser/create
  [{:keys [on-success name]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.advertiser-create/init (merge form/initial-value {:name (or name "")})])
                    (fn []
                      (rf/dispatch [:form.advertiser-create/destroy])))
                  [name])
  (let [form-values (use-subscribe [:form.advertiser-create/value []])
        {create-advertiser :mutate} (use-mutation (create-advertiser-mutation))
        on-create-success (fn [advertiser]
                            (let [advertiser (->clj advertiser)]
                              (rf/dispatch [:form.advertiser-create/create-product-store advertiser])
                              (js/setTimeout (fn []
                                               (rf/dispatch [:loader/close])
                                               (rf/dispatch [:modal/close])
                                               (on-success advertiser))
                                             500)))]
    ($ modal-v2
       {:title "Create advertiser"
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :on-mouse-down #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :onClick (fn []
                                  (create-advertiser form-values #js {:onSuccess on-create-success}))
                       :disabled (use-subscribe [:form.advertiser-create/errors?])}
                      "Create"))}
       ($ modal-content))))
